<template>
  <div class="validation-page main-container">
    <div>
      <h1>{{ $t('validation_page_title') }}</h1>
      <div>{{ $t('validation_page_subtitle') }}</div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import request from '@/api/api';

export default {
  data: () => ({
    validationUrl: process.env.VUE_APP_VALIDATION_URL || false,
  }),

  created() {
    if (this.validationUrl) {
      const { token } = this.$route.query;
      this.setValidation(token);

      request.$http.request({
        method: 'GET',
        url: `can_login/${token}`,
        baseURL: process.env.VUE_APP_VALIDATION_URL,
      })
        .then(res => {
          const { participationToken } = res.data.data;
          this.$router.push({
            name: 'Entry',
            query: {
              token: participationToken,
            },
          });
        })
        .catch(() => this.$router.push({ name: 'Error' }));
    }
  },

  methods: {
    ...mapMutations(['setValidation']),
  },
};
</script>

<style lang="scss" scoped>

.validation-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: unquote("max(60vw, 980px)");
  max-width: 100%;
  margin: auto;
}

</style>
